/**
 * Оценка высоты строки Excel по тексту с переносами.
 * ExcelJS не умеет autoFit по содержимому; ширина колонки в «символах»
 * заточена под латиницу, кириллица визуально шире — поэтому WRAP_CHAR_FACTOR < 1.
 */

/** Сколько «ширинных единиц» Excel реально занимает один символ при wrap (кириллица). */
export const WRAP_CHAR_FACTOR = 0.55;

export function estimateLineCount(
  value: unknown,
  colWidth: number,
  wrapCharFactor: number = WRAP_CHAR_FACTOR,
): number {
  const text = value == null ? "" : String(value);
  if (!text) return 0;

  const safeWidth = Math.max(1, Number(colWidth) || 25);
  const charsPerLine = Math.max(1, Math.floor(safeWidth * wrapCharFactor));
  const parts = text.split(/\r?\n/);
  let lines = 0;

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    lines += Math.max(1, Math.ceil(part.length / charsPerLine));
  }

  return lines;
}

/**
 * Высота строки в pt: max(minHeight, lines * linePt).
 * linePt ≈ fontSize + padding (Excel не совпадает 1:1 с CSS).
 */
export function estimateRowHeightPt(opts: {
  cells: Array<{ text?: unknown; colWidth: number }>;
  fontSize?: number;
  minHeight?: number;
  wrapCharFactor?: number;
}): number {
  const fontSize = opts.fontSize != null ? opts.fontSize : 12;
  const minHeight = opts.minHeight != null ? opts.minHeight : 30;
  const factor =
    opts.wrapCharFactor != null ? opts.wrapCharFactor : WRAP_CHAR_FACTOR;
  const linePt = Math.max(fontSize + 6, 18);

  let maxLines = 1;
  const cells = opts.cells || [];
  for (let i = 0; i < cells.length; i++) {
    const cell = cells[i];
    const lines = estimateLineCount(cell.text, cell.colWidth, factor);
    if (lines > maxLines) maxLines = lines;
  }

  return Math.max(minHeight, maxLines * linePt);
}
